/**
 * Dynamic resource loader for i18next. Translation JSONs are discovered at
 * build time via Vite's `import.meta.glob` and code-split per locale/namespace.
 *
 * Two lookup paths (ADR-014 layout). Namespace names are disjoint by
 * convention (feature folder names vs. generic shared names like `common`):
 *   - Feature-local:  /src/features/<namespace>/locales/<language>.json
 *   - Shared:         /src/shared/locales/<language>/<namespace>.json
 */

type ResourceModule = { default: Record<string, unknown> };

const featureResources = import.meta.glob<ResourceModule>(
  "/src/features/*/locales/*.json",
);
const sharedResources = import.meta.glob<ResourceModule>(
  "/src/shared/locales/*/*.json",
);

export async function loadResource(
  language: string,
  namespace: string,
): Promise<Record<string, unknown>> {
  const feature =
    featureResources[`/src/features/${namespace}/locales/${language}.json`];
  if (feature) return (await feature()).default;

  const shared =
    sharedResources[`/src/shared/locales/${language}/${namespace}.json`];
  if (shared) return (await shared()).default;

  throw new Error(`i18n: missing resource for "${language}/${namespace}"`);
}
